import script from "./CarCoaer.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarCoaer.vue?vue&type=script&lang=ts&setup=true"

import "./CarCoaer.vue?vue&type=style&index=0&id=6bdd8abd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bdd8abd"]])

export default __exports__